/**
* Tabbed Wysiwygs JS
* -----------------------------------------------------------------------------
*
* All the JS for the Tabbed Wysiwygs component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'tabbed-wysiwygs',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );

      const sections = document.querySelectorAll( '.tabbed-wysiwygs' );

      sections.forEach( ( section ) => {
        // console.log( idx );
        const tabs = section.querySelectorAll( '.tab-title' );
        const content = section.querySelectorAll( '.tabbed-content__content' );

        const clearContent = () => {
          content.forEach( ( cont, idx ) => {
            content[idx].classList.remove( 'active' );
            tabs[idx].classList.remove( 'active' );
          } );
        };

        tabs.forEach( ( tab, idx ) => {
          tab.addEventListener( 'click', () => {
            clearContent();
            const key = tab.dataset.key;
            content[key].classList.add( 'active' );
            tab.classList.add( 'active' );
          } );
        } );
      } );

      // $( '.tabbed-wysiwygs' ).each( function( idx ) {
      //   const tabs = section[idx].getElementsByClassName( 'tab-title' );
      //   const content = section[idx].getElementsByClassName( 'tabbed-content__content' );

      //   const clearContent = () => {
      //     content.forEach( ( cont, idx ) => {
      //       content[idx].classList.remove( 'active' );
      //       tabs[idx].classList.remove( 'active' );
      //     } );
      //   };

      //   tabs.forEach( ( tab, idx ) => {
      //     tab.addEventListener( 'click', () => {
      //       clearContent();
      //       const key = tab.dataset.key;
      //       content[key].classList.add( 'active' );
      //       tab.classList.add( 'active' );
      //     } );
      //   } );
      // } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'tabbed-wysiwygs', COMPONENT );
} )( app );
